<script setup lang="ts">
import Button from '@components/Button.vue'

const {
    aspectRatio = '16/9',
    enabled = false,
    text = 'Dieser Inhalt wird von einer externen Quelle geladen.',
} = defineProps<{
    aspectRatio?: string
    enabled?: boolean
    text?: string
}>()

const emits = defineEmits<{
    consent: []
}>()
</script>

<template>
    <div
        class="bg-neutral relative w-full *:first:relative *:first:z-10"
        :style="{
            aspectRatio,
        }"
    >
        <slot v-if="enabled" />
        <div
            v-else
            class="bg-neutral flex size-full flex-col items-center justify-center gap-y-4 rounded-md p-6 pb-8 text-center text-sm"
        >
            <p class="font-bold">Externer Inhalt</p>
            <p class="mb-2 max-w-lg">
                {{ text }} Durch „Akzeptieren“ erlaubst du, dass eventuell
                Cookies und Tracking genutzt werden.
            </p>
            <Button
                color="primary"
                @click="() => emits('consent')"
            >
                Akzeptieren
            </Button>
        </div>
        <span
            class="ph ph-[circle-notch] absolute top-1/2 left-1/2 z-0 size-8 -translate-1/2 animate-spin text-stone-400"
        ></span>
    </div>
</template>
